module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1512-2e4d969ac1f7890842b0bf6560a86f4b.png";